import { render } from "./IzinPresensi.vue?vue&type=template&id=bb7b64b4"
import script from "./IzinPresensi.vue?vue&type=script&lang=js"
export * from "./IzinPresensi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__